import { Component, OnDestroy, OnInit } from '@angular/core';
import {
    FormArray,
    FormBuilder,
    FormGroup,
    ValidationErrors,
} from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { CustomerHierarchyService } from '../customer-hierarchy.service';
@Component({
    selector: 'app-child-levels',
    templateUrl: './child-levels.component.html',
    styleUrls: ['./child-levels.component.scss'],
    standalone: false
})
export class ChildLevelsComponent implements OnInit, OnDestroy {
  parentNode: string;
  constructor(
    private readonly modalService: NgbModal,
    private readonly fb: FormBuilder,
    private readonly service: CustomerHierarchyService
  ) {}
  childsForm: FormGroup;
  submitted: boolean;
  createUpdateNodeSub: Subscription;
  ngOnInit(): void {
    this.childsForm = this.fb.group({
      childs: this.fb.array(
        [
          this.fb.group({ child: this.fb.control(null) }),
          this.fb.group({ child: this.fb.control(null) }),
          this.fb.group({ child: this.fb.control(null) }),
          this.fb.group({ child: this.fb.control(null) }),
          this.fb.group({ child: this.fb.control(null) }),
        ],
        { validators: this.checkFormValidity }
      ),
    });
  }
  ngOnDestroy(): void {
    this.createUpdateNodeSub?.unsubscribe();
  }
  childsArray(): FormArray {
    return this.childsForm?.get('childs') as FormArray;
  }
  addMoreFields() {
    for (let i = 0; i < 5; i++) {
      this.childsArray().push(this.fb.group({ child: this.fb.control(null) }));
    }
  }

  checkFormValidity(form: FormArray): ValidationErrors | null {
    return !form.pristine && form.value.some((val) => !!val.child)
      ? null
      : { formInvalid: true };
  }
  cancelPopup() {
    this.modalService.dismissAll();
  }
  addNewChilds() {
    this.submitted = true;
    let newChilds = this.childsArray()
      .value.filter((obj) => !!obj.child)
      .map((obj) => {
        return { name: obj['child'] };
      });

    let req = {
      parentNode: this.parentNode,
      customerHierarchyList: newChilds,
    };
    this.createUpdateNodeSub = this.service
      .createUpdateNode('create', req)
      .subscribe((res) => {
        if (res.status.toLowerCase() === 'success')
          this.modalService.dismissAll('success');
        else this.submitted = false;
      });
  }
}
